import { CheckCircle2, ClipboardCheck, Droplets, Hammer, PaintRoller, Ruler, Thermometer, Truck, Zap } from "lucide-react";
import { QuoteButton } from "../home/CtaButtons";

const ICONS = { CheckCircle2, ClipboardCheck, Droplets, Hammer, PaintRoller, Ruler, Thermometer, Truck, Zap };
const STEPS = [
  { icon: "Hammer", title: "Demontage", text: "Wij verwijderen uw oude kozijnen, puien of deuren zorgvuldig." },
  { icon: "Truck", title: "Levering", text: "Alles wordt op maat gemaakt en op de afgesproken dag geleverd." },
  { icon: "Thermometer", title: "HR++ of HR+++ glas", text: "Standaard HR++ isolatieglas; HR+++ waar het systeem dat toelaat." },
  { icon: "Ruler", title: "Montage", text: "Waterpas, luchtdicht en waterdicht geplaatst door ervaren monteurs." },
  { icon: "PaintRoller", title: "Afwerking", text: "Desgewenst verzorgen we de binnen- en buitenafwerking." },
];
const DEFAULT = {
  title: "Van demontage tot afwerking, door één partij", steps: STEPS,
  note: "Glas leveren wij altijd als onderdeel van nieuwe kozijnen, puien of deuren. Losse glasvervanging bieden wij niet aan.",
};

export const ServiceScope = ({ onderwerp, params, scope = DEFAULT }) => (
  <section id="werkwijze" aria-labelledby="scope-title" className="section scroll-mt-12" data-testid="product-scope">
    <div className="container-tight">
      <div className="relative overflow-hidden rounded-3xl bg-ink px-6 py-12 sm:px-10 sm:py-14 lg:px-14">
        <div className="hero-grid-dark absolute inset-0 opacity-60" aria-hidden="true" />
        <div className="relative">
          <p className="eyebrow !text-[#D9B97A]">Compleet geregeld</p>
          <h2 id="scope-title" className="h2 mt-3 max-w-2xl text-balance !text-white">{scope.title}</h2>
          <p className="mt-4 max-w-2xl leading-relaxed text-slate-300">
            U koopt bij ons niet alleen een product. Wij verzorgen het hele traject, met één vast aanspreekpunt van het eerste advies tot de oplevering.
          </p>
          <ol className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
            {scope.steps.map(({ icon, title, text }, i) => {
              const Icon = ICONS[icon];
              return (
              <li key={title} className="rounded-2xl border border-white/10 bg-white/5 p-5" data-testid={`scope-step-${i + 1}`}>
                <div className="flex items-center justify-between">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 text-[#7FD3D6]"><Icon className="h-5 w-5" aria-hidden="true" /></span>
                  <span className="font-display text-[13px] font-bold text-white/40">0{i + 1}</span>
                </div>
                <h3 className="mt-4 text-[16px] font-semibold text-white">{title}</h3>
                <p className="mt-1.5 text-[14px] leading-relaxed text-slate-300">{text}</p>
              </li>
              );
            })}
          </ol>
          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <p className="max-w-xl text-[13.5px] leading-relaxed text-slate-400" data-testid="product-scope-note">{scope.note}</p>
            <QuoteButton location="product-scope" onderwerp={onderwerp} params={params} className="w-full sm:w-auto" />
          </div>
        </div>
      </div>
    </div>
  </section>
);
